module.exports = __webpack_public_path__ + "static/images/components/NavigationArrow/images/arrow-right-hover-small.7a9b5dbc.png";


//////////////////
// WEBPACK FOOTER
// ./components/NavigationArrow/images/arrow-right-hover-small.png
// module id = 2648
// module chunks = 11